import types from "../../../actions/types";

export default Object.freeze({
  ...types,
  ACTIVITY_GET_LIST: "ACTIVITY_GET_LIST",
  ACTIVITY_RESET_LIST: "ACTIVITY_RESET_LIST",
  ACTIVITY_REMOVE: "ACTIVITY_REMOVE"
});
